import type { ArealplanDelområde } from '@origo/arealplan';

/** Delområder på bakken (SOSI VERTNIV 2) eller med ukjent nivå. */
export const PAA_BAKKEN_TEKST = 'På bakken';

/**
 * Vertikalnivåene utenom «på bakken», i den rekkefølgen de vises under hver
 * sin underoverskrift i delområde-treet — etter «på bakken», med «under
 * bakken» nederst.
 */
export const ANDRE_VERTIKALNIVAER: ReadonlyArray<{ kode: string; tekst: string }> = [
    { kode: '3', tekst: 'Over bakken' },
    { kode: '5', tekst: 'I vannsøylen' },
    { kode: '4', tekst: 'På bunnen' },
    { kode: '1', tekst: 'Under bakken' },
];

export function vertikalnivåTekst(kode: string): string | undefined {
    return ANDRE_VERTIKALNIVAER.find((n) => n.kode === kode)?.tekst;
}

/**
 * Vertikalnivå-koden for et delområde som ikke ligger på bakken, ellers
 * undefined. Hvert vertikalnivå er en egen FeatureServer
 * (`Reguleringsplan_VN1` …), så nivået leses fra `planTypeKey`;
 * VERTNIV-attributtet er fallback.
 */
export function vertikalnivåFor(feature: ArealplanDelområde): string | undefined {
    const vertNiv = /_VN(\d+)$/.exec(feature.planTypeKey)?.[1] ?? feature.attributter.VERTNIV;
    const kode = String(vertNiv ?? '');
    return vertikalnivåTekst(kode) ? kode : undefined;
}
